export const ACTIONS = ["list", "show", "answer", "cancel"] as const;
